<template>
<div>
    <div class="d-flex flex-column-fluid">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <!-- height:auto - the theme stretches a gutter-b card to the column, which left a gap under the title -->
                    <div class="card card-custom gutter-b bg-transparent shadow-none border-0" style="height: auto">
                        <div class="card-header align-items-center border-bottom-dark px-0">
                            <div class="card-title mb-0">
                                <h3 class="card-label mb-0 font-weight-bold text-body">Подарки к товарам</h3>
                            </div>
                            <div class="card-toolbar">
                                <button v-if="!form" type="button" class="btn btn-primary" @click="startNew">+ Новая акция</button>
                            </div>
                        </div>
                    </div>

                    <!-- Form -->
                    <div v-if="form" class="card card-custom gutter-b bg-white border-0" style="height: auto">
                        <div class="card-body">
                            <h5 class="text-dark mb-4">{{ form.id ? 'Акция «' + form.name + '»' : 'Новая акция' }}</h5>

                            <div class="form-row">
                                <div class="col-md-6 mb-3">
                                    <label class="text-dark">Название</label>
                                    <input type="text" class="form-control" v-model="form.name" placeholder="например Подарок к SMART BED">
                                    <small class="text-danger" v-if="err('name')">{{ err('name') }}</small>
                                </div>
                                <div class="col-md-3 mb-3">
                                    <label class="text-dark">Начало</label>
                                    <input type="datetime-local" class="form-control" v-model="form.starts_at">
                                    <small class="text-danger" v-if="err('starts_at')">{{ err('starts_at') }}</small>
                                </div>
                                <div class="col-md-3 mb-3">
                                    <label class="text-dark">Окончание</label>
                                    <input type="datetime-local" class="form-control" v-model="form.ends_at">
                                    <small class="text-danger" v-if="err('ends_at')">{{ err('ends_at') }}</small>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col-md-3 mb-3 d-flex align-items-center">
                                    <div class="custom-control switch custom-switch-info custom-switch custom-control-inline mr-0">
                                        <input type="checkbox" class="custom-control-input" id="gp-active" v-model="form.is_active">
                                        <label class="custom-control-label mr-1" for="gp-active"></label>
                                    </div>
                                    <span class="text-dark">Акция включена</span>
                                </div>
                                <div class="col-md-3 mb-3 d-flex align-items-center">
                                    <div class="custom-control switch custom-switch-info custom-switch custom-control-inline mr-0">
                                        <input type="checkbox" class="custom-control-input" id="gp-stock" v-model="form.check_stock">
                                        <label class="custom-control-label mr-1" for="gp-stock"></label>
                                    </div>
                                    <span class="text-dark">Учитывать остатки подарков</span>
                                </div>
                                <div class="col-md-3 mb-3">
                                    <label class="text-dark">Если подарков нет в наличии</label>
                                    <select class="form-control" v-model="form.when_none" :disabled="!form.check_stock">
                                        <option value="hide">Скрыть попап</option>
                                        <option value="notice">Показать «подарки закончились»</option>
                                    </select>
                                </div>
                                <div class="col-md-3 mb-3">
                                    <label class="text-dark">Подарков на 1 товар</label>
                                    <input type="number" min="1" max="10" class="form-control" v-model.number="form.gifts_per_item">
                                    <small class="text-danger" v-if="err('gifts_per_item')">{{ err('gifts_per_item') }}</small>
                                </div>
                            </div>
                            <small v-if="!form.check_stock" class="form-text text-muted mt-n2 mb-3">
                                Остатки не учитываются: покупатель увидит все подарки, даже если их нет на складе.
                            </small>

                            <div class="form-row">
                                <div class="col-md-6 mb-3">
                                    <label class="text-dark">Тестовый email</label>
                                    <input type="email" class="form-control" v-model="form.test_email" placeholder="пусто - акцию видят все">
                                    <small class="form-text text-muted">Пока заполнено - акцию видит только покупатель с этим email на сайте.</small>
                                    <small class="text-danger" v-if="err('test_email')">{{ err('test_email') }}</small>
                                </div>
                            </div>

                            <!-- Products -->
                            <div class="form-row">
                                <div class="col-md-6 mb-3" v-for="list in ['triggers', 'gifts']" :key="list">
                                    <label class="text-dark font-weight-bold">{{ list === 'triggers' ? 'Товары, к которым положен подарок' : 'Подарки на выбор' }}</label>
                                    <div class="position-relative">
                                        <input type="text" class="form-control" v-model="search[list]" @input="find(list)"
                                               placeholder="Найти по SKU или названию">
                                        <div v-if="found[list].length" class="dropdown-menu show w-100" style="max-height:280px;overflow:auto">
                                            <a v-for="p in found[list]" :key="p.id" href="#" class="dropdown-item d-flex justify-content-between"
                                               @click.prevent="add(list, p)">
                                                <span><span class="text-muted">{{ p.sku }}</span> {{ p.title }}</span>
                                                <span class="small ml-2 text-nowrap" :class="p.opencart_id ? 'text-muted' : 'text-danger'">
                                                    {{ p.opencart_id ? (p.stock === null ? 'с вариантами' : 'остаток ' + p.stock) : 'не на сайте' }}
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    <table class="table table-sm mt-2 mb-0" v-if="form[list].length">
                                        <tbody>
                                            <tr v-for="(p, i) in form[list]" :key="p.id">
                                                <td class="text-muted text-nowrap">{{ p.sku }}</td>
                                                <td>{{ p.title }}</td>
                                                <td class="text-nowrap small" :class="stockClass(list, p)">
                                                    {{ !p.opencart_id ? 'не на сайте' : (p.variable ? 'с вариантами' : 'остаток ' + p.stock) }}
                                                </td>
                                                <td class="text-right text-nowrap">
                                                    <button v-if="list === 'gifts'" type="button" class="btn btn-sm btn-light px-2" :disabled="i === 0" @click="move(list, i, -1)">↑</button>
                                                    <button v-if="list === 'gifts'" type="button" class="btn btn-sm btn-light px-2" :disabled="i === form[list].length - 1" @click="move(list, i, 1)">↓</button>
                                                    <button type="button" class="btn btn-sm btn-light text-danger px-2" @click="form[list].splice(i, 1)">✕</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div v-else class="text-muted small mt-2">Пока ничего не выбрано.</div>
                                    <div class="text-danger small" v-for="m in errs(list)" :key="m">{{ m }}</div>
                                </div>
                            </div>

                            <div class="d-flex">
                                <button type="button" class="btn btn-primary" :disabled="busy" @click="save">Сохранить</button>
                                <button type="button" class="btn btn-light ml-2" :disabled="busy" @click="form = null">Отмена</button>
                                <button v-if="form.id" type="button" class="btn btn-light text-danger ml-auto" :disabled="busy" @click="remove">Удалить акцию</button>
                            </div>
                        </div>
                    </div>

                    <!-- List -->
                    <div v-if="!form" class="card card-custom gutter-b bg-white border-0" style="height: auto">
                        <div class="card-body">
                            <div v-if="!promotions.length" class="text-muted py-4 text-center">Акций пока нет.</div>
                            <table v-else class="table">
                                <thead>
                                    <tr>
                                        <th>Название</th>
                                        <th>Период</th>
                                        <th>Статус</th>
                                        <th>Товаров</th>
                                        <th>Подарков</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="p in promotions" :key="p.id">
                                        <td>
                                            {{ p.name }}
                                            <div v-if="p.test_email" class="small text-warning">Тест: только {{ p.test_email }}</div>
                                        </td>
                                        <td class="text-nowrap">{{ p.starts_at }} — {{ p.ends_at }}</td>
                                        <td><span class="badge" :class="states[p.state].cls">{{ states[p.state].label }}</span></td>
                                        <td>{{ p.triggers_count }}</td>
                                        <td>{{ p.gifts_count }}</td>
                                        <td class="text-right"><button type="button" class="btn btn-sm btn-light" @click="open(p.id)">Изменить</button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
const blank = () => {
    const pad = n => String(n).padStart(2, '0');
    const day = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const start = new Date();
    start.setDate(start.getDate() + 1);
    const end = new Date(start);
    end.setDate(end.getDate() + 7);

    return {
        id: null,
        name: '',
        is_active: true,
        starts_at: day(start) + 'T00:00',
        ends_at: day(end) + 'T23:59',
        check_stock: true,
        when_none: 'hide',
        gifts_per_item: 1,
        test_email: '',
        triggers: [],
        gifts: [],
    };
};

export default {
    data() {
        return {
            promotions: [],
            form: null,
            errors: {},
            busy: false,
            search: { triggers: '', gifts: '' },
            found: { triggers: [], gifts: [] },
            timers: {},
            states: {
                active: { label: 'Идёт', cls: 'badge-success' },
                scheduled: { label: 'Запланирована', cls: 'badge-info' },
                ended: { label: 'Закончилась', cls: 'badge-secondary' },
                off: { label: 'Выключена', cls: 'badge-light' },
            },
        };
    },
    computed: {
        config() {
            return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
        },
    },
    methods: {
        fetch() {
            this.$parent.loading = true;
            axios.get('/api/admin/gift-promotions', this.config)
                .then(res => { this.promotions = res.data.data || []; })
                .finally(() => (this.$parent.loading = false));
        },
        startNew() {
            this.errors = {};
            this.form = blank();
        },
        open(id) {
            this.errors = {};
            this.$parent.loading = true;
            axios.get(`/api/admin/gift-promotions/${id}`, this.config)
                .then(res => { this.form = { ...res.data.data, test_email: res.data.data.test_email || '' }; })
                .finally(() => (this.$parent.loading = false));
        },
        find(list) {
            clearTimeout(this.timers[list]);
            const q = this.search[list].trim();
            if (q.length < 2) { this.found[list] = []; return; }
            this.timers[list] = setTimeout(() => {
                axios.get('/api/admin/gift-promotions/products', { ...this.config, params: { q } })
                    .then(res => { this.found[list] = res.data.data || []; });
            }, 250);
        },
        add(list, product) {
            if (!this.form[list].some(p => p.id === product.id)) {
                this.form[list].push(product);
            }
            this.search[list] = '';
            this.found[list] = [];
        },
        move(list, i, step) {
            const rows = this.form[list].slice();
            const [row] = rows.splice(i, 1);
            rows.splice(i + step, 0, row);
            this.form[list] = rows;
        },
        stockClass(list, p) {
            if (!p.opencart_id || (list === 'gifts' && p.variable)) return 'text-danger';
            if (list === 'gifts' && p.stock <= 0) return 'text-warning';
            return 'text-muted';
        },
        err(field) {
            return this.errors[field] ? this.errors[field][0] : null;
        },
        errs(field) {
            return Object.keys(this.errors)
                .filter(k => k === field || k.indexOf(field + '.') === 0)
                .reduce((all, k) => all.concat(this.errors[k]), []);
        },
        save() {
            const payload = {
                ...this.form,
                test_email: this.form.test_email || null,
                triggers: this.form.triggers.map(p => p.id),
                gifts: this.form.gifts.map(p => p.id),
            };
            const request = this.form.id
                ? axios.put(`/api/admin/gift-promotions/${this.form.id}`, payload, this.config)
                : axios.post('/api/admin/gift-promotions', payload, this.config);

            this.busy = true;
            this.errors = {};

            request
                .then(res => {
                    this.$toaster.success(res.data.message || 'Сохранено');
                    this.form = null;
                    this.fetch();
                })
                .catch(error => {
                    const data = error.response && error.response.data;
                    this.errors = (data && data.errors) || {};
                    this.$toaster.error((data && data.message) || 'Не удалось сохранить');
                })
                .finally(() => { this.busy = false; });
        },
        remove() {
            if (!confirm(`Удалить акцию «${this.form.name}»? Сайт перестанет предлагать подарки по ней.`)) {
                return;
            }

            this.busy = true;
            axios.delete(`/api/admin/gift-promotions/${this.form.id}`, this.config)
                .then(() => {
                    this.$toaster.success('Акция удалена');
                    this.form = null;
                    this.fetch();
                })
                .finally(() => { this.busy = false; });
        },
    },
    mounted() {
        this.fetch();
    },
};
</script>
